import { FormControl } from '@angular/forms';
import { DirectDebitFormField } from './direct-debit-form-field.enum';

export interface DirectDebitForm {
  [DirectDebitFormField.AccountName]: FormControl<string | null>;
  [DirectDebitFormField.AccountNumber]: FormControl<string | null>;
  [DirectDebitFormField.IBAN]: FormControl<string | null>;
  [DirectDebitFormField.SortCode]: FormControl<string | null>;
  [DirectDebitFormField.PaymentDate]: FormControl<number | null>;
  [DirectDebitFormField.AccountHolderConfirmation]: FormControl<boolean | null>;
  [DirectDebitFormField.TermsAndConditions]: FormControl<boolean | null>;
  [DirectDebitFormField.PaperlessPreference]: FormControl<boolean | null>;
  [DirectDebitFormField.PaymentToken]: FormControl<string | null>;
}
